// notifications.ts — API helpers for the message queue endpoints.
//
// Unwrap pattern: apiClient.get/post returns ApiSuccess<T> directly
// (the interceptor resolves the axios promise to r.data which is the
// ApiSuccess envelope). Callers access .data to get the inner payload.

import { apiClient } from './client';
import { endpoints } from './endpoints';
import type { MessageQueueListResponse, MessageQueueSummary, FlushQueueResponse } from '../types/api';

export interface QueueFilters {
  status: 'all' | 'pending' | 'processing' | 'sent' | 'failed' | 'cancelled';
  type: 'all' | 'email' | 'sms';
  page: number;
  limit: number;
}

export async function fetchQueue(f: QueueFilters): Promise<MessageQueueListResponse> {
  const res = await apiClient.get<MessageQueueListResponse>(endpoints.notifications.queue, {
    params: f,
  });
  return res.data;
}

export async function fetchSummary(): Promise<MessageQueueSummary> {
  const res = await apiClient.get<MessageQueueSummary>(endpoints.notifications.queueSummary);
  return res.data;
}

export async function postFlush(): Promise<FlushQueueResponse> {
  const res = await apiClient.post<FlushQueueResponse>(endpoints.notifications.flush);
  return res.data;
}
